<template>
  <div>
  <MonthPressPurchaseList tabTitle="하드웨어입고내역" materialType="S0404" pType="하드웨어"/>
  </div>
</template>

<script>
import MonthPressPurchaseList from './MonthPressPurchaseList'

export default {
  name: 'MonthHardwareList',
  data: function () {
    return {

    }
  },
  components: {
    MonthPressPurchaseList
  },
  created () {

  },
  mounted () {

  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {

  }
}
</script>

<style lang="scss">

</style>
